import { MutationCache, QueryCache, QueryClient } from "@tanstack/react-query";
import { APP_MUTATION_SCOPE } from "./mutationScope";

/**
 * Global QueryClient configuration for React Query.
 *
 * Features:
 * - 5-minute staleTime for infrequently changing agricultural data
 * - 30-minute gcTime to improve navigation performance
 * - refetchOnWindowFocus disabled for Capacitor mobile compatibility
 * - Global error logging for all queries and mutations
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes - data considered fresh
      gcTime: 1000 * 60 * 30, // 30 minutes - keep in memory longer for navigation
      retry: 1,
      refetchOnWindowFocus: false,
    },
    mutations: {
      scope: APP_MUTATION_SCOPE,
    },
  },
  queryCache: new QueryCache({
    onError: (error, query) => {
      // Log all query errors for observability
      // In production, this could send to an error tracking service
      console.error(
        `[React Query] Query failed: ${JSON.stringify(query.queryKey)}`,
        error
      );
    },
  }),
  mutationCache: new MutationCache({
    onError: (error, _variables, _context, mutation) => {
      // Log all mutation errors for observability
      const mutationKey = mutation.options.mutationKey;
      console.error(
        `[React Query] Mutation failed${
          mutationKey ? `: ${JSON.stringify(mutationKey)}` : ""
        }`,
        error
      );
    },
  }),
});
